import { NAV_LINKS } from "../../data";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/10 bg-black">
    <div className="mx-auto max-w-7xl px-6 py-16 md:px-12 md:py-20">
      <div className="flex flex-col justify-between gap-12 md:flex-row">
        <div className="max-w-sm">
          <div className="flex items-center gap-2.5">
            <span className="flex h-8 w-8 items-center justify-center border border-white/20 bg-[#00F0FF]">
              <span className="font-heading text-xl font-black leading-none text-black">F</span>
            </span>
            <span className="font-heading text-xl font-extrabold uppercase tracking-tight text-white">
              Fuel<span className="text-[#00F0FF]">Factory</span>
            </span>
          </div>
          <p className="mt-5 font-body text-sm text-white/50">
            Biomechanics-driven baseball performance training. Train the mechanics. Trust
            the data. Own the mound.
          </p>
          <a
            href="mailto:fuelfactory1@gmail.com"
            className="mt-4 inline-block font-mono text-sm text-white/60 transition-colors hover:text-[#00F0FF]"
          >
            fuelfactory1@gmail.com
          </a>
          <div className="mt-5 flex items-center gap-3">
            <a
              href="https://instagram.com/the_fuel_factory_"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-social-instagram"
              className="font-mono text-xs uppercase tracking-wider text-white/50 transition-colors hover:text-[#00F0FF]"
            >
              Instagram
            </a>
            <span className="text-white/20">/</span>
            <a
              href="https://tiktok.com/@the.fuel.factory"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-social-tiktok"
              className="font-mono text-xs uppercase tracking-wider text-white/50 transition-colors hover:text-[#00F0FF]"
            >
              TikTok
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-10 sm:grid-cols-2">
          <div>
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#00F0FF]">
              Navigate
            </span>
            <ul className="mt-4 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="font-body text-sm text-white/55 transition-colors hover:text-white"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#00F0FF]">
              Get Started
            </span>
            <ul className="mt-4 space-y-3">
              <li>
                <a href="#programs" className="font-body text-sm text-white/55 transition-colors hover:text-white">
                  Programs
                </a>
              </li>
              <li>
                <a href="#contact" className="font-body text-sm text-white/55 transition-colors hover:text-white">
                  Book Assessment
                </a>
              </li>
              <li>
                <a href="#founders" className="font-body text-sm text-white/55 transition-colors hover:text-white">
                  Meet the Founders
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    {/* Massive wordmark */}
    <div className="overflow-hidden border-t border-white/10 px-6 md:px-12">
      <h2 className="select-none py-8 font-heading text-[19vw] font-black uppercase leading-none tracking-tighter text-white/5">
        Fuel Factory
      </h2>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 py-6 md:flex-row md:px-12">
        <p className="font-mono text-[11px] uppercase tracking-wider text-white/35">
          © {new Date().getFullYear()} Fuel Factory. All rights reserved.
        </p>
        <p className="font-mono text-[11px] uppercase tracking-wider text-white/35">
          Science. Data. Results.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
